import store from '@/store/index.js'
let dic = store.state.dic;

export default function Configs(that) {

    const searchItems = [
        {
            label: "学院",
            span: 8,
            type: 'select',
            model: "collegeName",
            options: [],
            clearable: true,
        },
        {
            label: "学号",
            prop: "studentNo",
            span: 8,
            placeholder: '请输入学号',
            model: "studentNo",
        },
        {
            label: "姓名",
            span: 8,
            placeholder: '请输入姓名',
            model: "studentName",
        },
        {
            label: "缴费情况",
            span: 8,
            type: 'select',
            // labelWidth: '180px',
            model: "isPayTotal",
            clearable: true,
            options: [
                {
                    label: '全部已缴',
                    value: '全部已缴'
                },
                {
                    label: '部分已缴',
                    value: '部分已缴'
                },
                {
                    label: '未缴费',
                    value: '未缴费'
                }
            ],
        },
        {
            label: "是否贷款",
            span: 8,
            type: 'select',
            // labelWidth: '180px',
            model: "isLoan",
            options: [
                {
                    label: '是',
                    value: '是'
                },
                {
                    label: '否',
                    value: '否'
                },
                {
                    label: '未办理',
                    value: '未办理'
                }
            ],
            clearable: true,
        },

    ]
    const tableColumns = [
        {
            label: "学号",
            prop: "studentNo",
            align: "center",
            minWidth: 140,
            show: true
        },
        {
            label: "身份证号",
            prop: "idCard",
            align: "center",
            minWidth: 180,
            show: true
        },
        {
            label: "姓名",
            prop: "studentName",
            align: "center",
            minWidth: 120,
            show: true
        },
        {
            label: "性别",
            prop: "sexName",
            align: "center",
            show: true
        },
        {
            label: "学院",
            prop: "collegeName",
            align: "center",
            minWidth: 260,
            show: true
        },
        {
            label: "专业",
            prop: "majorName",
            align: "center",
            minWidth: 260,
            show: true
        },
        {
            label: "应缴金额",
            prop: "shouldPayAmount",
            align: "center",
            // minWidth: 260,
            show: true
        },
        {
            label: "实缴金额",
            prop: "paidAmount",
            align: "center",
            // minWidth: 260,
            show: true
        },
        {
            label: "欠费金额",
            prop: "oweAmount",
            align: "center",
            // minWidth: 260,
            show: true
        },
        {
            label: "是否已缴完",
            prop: "isPayTotal",
            align: "center",
            minWidth: 120,
            show: true
        },
        {
            label: "是否贷款",
            prop: "isLoan",
            align: "center",
            // minWidth: 180,
            show: true
        },
        {
            label: "贷款金额",
            prop: "loanAmount",
            align: "center",
            // minWidth: 180,
            show: true
        },
        {
            label: "操作",
            name: "custom",
            align: "center",
            width: '120px',
            show: true
        }
    ]

    const tableColumnsDetail = [
        {
            label: "缴费项目名称",
            prop: "feeItemName",
            align: "center",
            minWidth: 180,
            show: true
        },
        {
            label: "应缴金额",
            prop: "shouldPayAmount",
            align: "center",
            show: true
        },
        {
            label: "实缴金额",
            prop: "paidAmount",
            align: "center",
            show: true
        },
        {
            label: "欠费金额",
            prop: "oweAmount",
            align: "center",
            show: true
        },
        {
            label: "减免金额",
            prop: "creditAmount",
            align: "center",
            minWidth: 120,
            show: true
        },
        {
            label: "退费金额",
            prop: "refundAmount",
            align: "center",
            show: true
        },
    ]

    return {
        searchItems,
        tableColumns,
        tableColumnsDetail
    }
}
